import { render, staticRenderFns } from "./LoginDeleteAccount.vue?vue&type=template&id=35d899a9&"
import script from "./LoginDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./LoginDeleteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports